module.exports = __webpack_public_path__ + "static/Havelsan-fe1e045fc2659b87156eee7e3b5bdbf0.jpeg";